import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Register service worker for PWA support
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('[SW] registered', reg.scope);
        // Listen for updates and reload automatically so pinned app stays fresh
        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          if (newSW) {
            newSW.addEventListener('statechange', () => {
              if (newSW.state === 'activated') {
                // New SW activated — reload to get fresh content
                window.location.reload();
              }
            });
          }
        });
      })
      .catch(err => console.warn('[SW] registration failed', err));

    // Also listen for message from SW to reload
    navigator.serviceWorker.addEventListener('message', e => {
      if (e.data && e.data.type === 'SW_UPDATED') {
        window.location.reload();
      }
    });
  });
}
